<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center mb-2">
      <v-btn color="primary" tile outlined @click="getdata()">
        <v-icon small>mdi-reload</v-icon>刷新
      </v-btn>
      <v-btn color="success" tile @click="showadd">
        <v-icon small>mdi-plus</v-icon>新增权限
      </v-btn>
    </div>
    <v-card>
      <v-data-table dense :headers="headers" :items="list" :items-per-page="list.length" no-data-text="无数据"
        hide-default-footer disable-sort fixed-header :height="height">
        <template v-slot:item.list="{ item }">
          <div class="d-flex flex-column justify-center align-left">
            <span v-for="(citem, index) in item.list" :key="index">
              {{ citem.title }} { {{ citem.url }} }
            </span>
          </div>
        </template>
        <template v-slot:item.enabled="{ item }">
          <span v-if="item.enabled" class="success--text">启用</span>
          <span v-else class="error--text">禁用</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn text color="success" @click="showedit(item)">
            编辑
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="model" persistent max-width="400px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="form.title" :rules="[vrules.required]" placeholder="权限组" persistent-placeholder
                    dense outlined>
                    <template v-slot:label>
                      权限组 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                  <v-textarea v-model="permissions" placeholder="每行一个,title+url,空格隔开" rows="10" outlined dense>
                    <template v-slot:label>
                      权限列表
                    </template>
                  </v-textarea>
                  <v-checkbox v-model="form.enabled" dense>
                    <template v-slot:label>
                      <span :class="`${form.enabled ? 'success--text' : 'error--text'}`">
                        {{ form.enabled ? '启用' : '禁用' }}
                      </span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "SystemAccount",
  data() {
    return {
      valid: true,
      headers: [
        { text: "权限组", value: "title", width: 150 },
        { text: "权限列表", value: "list" },
        { text: "状态", value: "enabled", align: "center" },
        { text: "创建时间", value: "create_time" },
        { text: "操作", value: "action", width: 120, fixed: "right" },
      ],
      list: [],
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      form: {},
      permissions: "",
      height: 600,
    };
  },
  computed: {
    ...mapState(["username"]),
  },
  components: {},
  watch: {},
  mounted() {
    this.height = window.innerHeight - 150;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 150;
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/permission/list").then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list.map(n => {
            return {
              ...n,
              create_time: this.$utils.dateFormat(n.create_time, 'YYYY-MM-DD HH:mm:ss'),
            };
          });
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = { _id: "", title: "", enabled: true };
      this.permissions = "";
      this.modeltitle = "新增权限";
      this.model = true;
    },
    showedit(item) {
      this.form = { _id: item._id, title: item.title, enabled: item.enabled };
      this.permissions = item.list.map(n => `${n.title} ${n.url}`).join('\n');
      this.modeltitle = "编辑权限";
      this.model = true;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      let dataForm = {
        _id: this.form._id,
        title: this.form.title,
        list: this.permissions.trim().split('\n').map(n => {
          let [title, url] = n.split(' ');
          return { title, url };
        }),
        enabled: this.form.enabled,
      }
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/permission/save", { dataForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

p {
  margin: 0;
}
</style>
